var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { isKeyValueObject, isKeyValueObjectType, } from "@haipham/javascript-helper-object";
export * from "./constant";
export * from "./createValidator";
export * from "./i18n";
export * from "./stringifyEvaluationResult";
export function promisifyObservableConvertible(args) {
    return __awaiter(this, void 0, void 0, function () {
        var isObservable, take, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, import("rxjs")];
                case 1:
                    isObservable = (_a.sent()).isObservable;
                    return [4 /*yield*/, import("rxjs/operators")];
                case 2:
                    take = (_a.sent()).take;
                    return [4 /*yield*/, Promise.resolve(args)];
                case 3:
                    result = _a.sent();
                    if (isObservable(result)) {
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                /**
                                 * There's no need to handle the subscription here, since we are only
                                 * taking a maximum of 1 emission from the Observable.
                                 */
                                return result.pipe(take(1)).subscribe({ next: resolve, error: reject });
                            })];
                    }
                    return [2 /*return*/, result];
            }
        });
    });
}
export function isValidRegExpMatchResult(args) {
    return isKeyValueObjectType(args, {
        groups: {
            validator: function () {
                var _a = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    _a[_i] = arguments[_i];
                }
                var _b = __read(_a, 2), value = _b[1];
                return isKeyValueObject(value);
            },
        },
        matches: {
            validator: function () {
                var _a = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    _a[_i] = arguments[_i];
                }
                var _b = __read(_a, 2), value = _b[1];
                return Array.isArray(value);
            },
        },
    });
}
export function polyfillProcess() {
    return __awaiter(this, void 0, void 0, function () {
        var processPolyfill;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (global.process != null) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, import("process/browser")];
                case 1:
                    processPolyfill = _a.sent();
                    global.process = processPolyfill;
                    return [2 /*return*/];
            }
        });
    });
}
